import { ModelBase } from '../../shared/base/model-base';

export class User extends ModelBase {
  name: string;
  email: string;
  avatarUrl: string;
  latestLessonUrl: string;
  latestNotificationsTimestamp: number;
  colorTheme: string;

  update(updatedUser: User) {
    if (updatedUser.hasOwnProperty('latestLessonUrl')) {
      this.latestLessonUrl = updatedUser.latestLessonUrl;
    }
  }

  updateColorTheme(updatedUser: User) {
    if (updatedUser.hasOwnProperty('colorTheme')) {
      this.colorTheme = updatedUser.colorTheme;
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/shared/user.ts